module.exports = __webpack_public_path__ + "static/media/deck_ona.405ea4bd.jpg";